import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationStart } from '@angular/router';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { overlayConfigFactory } from 'angular2-modal';
import { DialogRef, ModalComponent } from 'angular2-modal';
import { loyaltyCardverificationComponent } from './loyalty-login.component-Step2';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
//Services
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { loyaltylogin } from '../../_services/userservice/user.loyaltylogin.service';
import { AlertPopupComponent } from '../../sharedcomponents/_directive/alert-popup/alert-popup.component';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-loyalty-login',
  templateUrl: './loyalty-login.component-Step1.html',
  styleUrls: ['./loyalty-login.component.css'],
  providers: [loyaltylogin, AlertService]
})
export class LoyaltyLoginComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  model: any = {};
  appSettings: any = {};
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    public utilserv: utilityService,
    private loyallog: loyaltylogin,
    public modal: Modal,
    private translate: TranslateService,
    private alertService: AlertService,
    public vcref: ViewContainerRef,
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    this.appSettings = AppSettings;
  }

  ngOnInit() {
    this.context = this.dialog.context;
  }
  verifyLoyaltyCard() {
    this.utilserv.busy = this.loyallog.verifyLoyaltyCard(this.model).subscribe(data => {
      const resJSON = data;
      const _self = this;
      if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS) {
        sessionStorage.loyaltyCardNumber = this.model.loyaltyCardNumber;
        this.model.MobileNumber = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.MobileNumber);
        this.model.CustomerEmail = this.utilserv.getObjectText(resJSON.Envelope.Body.CustomerInfoResponse.CustomerEmail);
        this.dialog.close();
        this.openLoyaltyCardVerificationStep2(this.model);
      } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.loylty_already_linked) {
        const modalData: any = {};
        modalData.Title = this.translate.instant('Common_lblOops').toString();
        modalData.Message = this.translate.instant('LoyaltyLinkPopup_desc');
        modalData.Action = this.translate.instant('Common_lblContinue');
        // this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), this.translate.instant('LoyaltyLinkPopup_desc'));
        return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
          obj.onDestroy.subscribe(error => {});
        });
      } else if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.loylty_invalid_card_num) {
        if (this.context.modalData.isLoggedIn == false) {
          const modalData: any = {};
          modalData.Title = this.translate.instant('Common_lblOops').toString();
          modalData.Message = this.translate.instant('WrongLoyaltyPopup_desc');
          modalData.Action = this.translate.instant('Common_lblContinue');
          modalData.isClose = true;

          return this.modal.open(AlertPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function(obj) {
            obj.onDestroy.subscribe(error => {
              if (modalData.next == 'yes') {
                _self.router.navigate(['/register']);
              }
            });
          });
        } else {
          this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
        }
      } else {
        this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
      }
    });
  }

  // For opening Loyalty Card Verification screen
  openLoyaltyCardVerificationStep2(loyaltyCardModel: any) {
    loyaltyCardModel.isLoggedIn = this.context.modalData.isLoggedIn;
    return this.modal.open(loyaltyCardverificationComponent, overlayConfigFactory({ loyaltyCardModel }, BSModalContext));
  }

  // for closing existing dialog Box
  closePopup() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/loyalty-login/loyalty-login.component-Step1.ts